export default __webpack_public_path__ + "static/media/choose_teams_main.a9ed588c.jpg";